<div class="optimization">
  <div class="container">
    <form [formGroup]="formGroup">
      <div class="header">
        <pdq-heading element="h5">Display optimization</pdq-heading>
        <pdq-slide-toggle formControlName="enableOptimization"></pdq-slide-toggle>
      </div>

      <div class="content">
        <span class="link"
          >Simplify checkout by removing shipping methods that compete with each other based on speed and price.
          <pdq-link
            [external]="true"
            label="Learn more"
            [url]="
              'https://support.prettydamnquick.com/en/articles/6903653-display-optimization-at-checkout'
            "></pdq-link
        ></span>

        <div class="content">
          <div class="subheader">
            <pdq-checkbox
              label=""
              [disabled]="!formGroup.value['enableOptimization']"
              formControlName="enableIncreaseRatesPercentage"></pdq-checkbox>
            <pdq-heading element="h6">Then optimize shipping revenue</pdq-heading>
          </div>
          <ul>
            <li>
              <span class="item-content"
                >Don't display methods that cost more than x% of total cart value
                <pdq-icon
                  icon="more_information"
                  color="snorlax"
                  [matTooltip]="'Cart value can mean subtotal or total of cart, as chosen in your checkout settings'"
                  matTooltipClass="pdq-mat-tooltip">
                </pdq-icon
              ></span>
              <span style="color: var(--on-surface-light)"
                >If there is no method to show: this rule won’t be applied</span
              >
            </li>
            <li><span>Round up to x% of order value of the fastest delivery method</span></li>
          </ul>
        </div>

        <div class="actions">
          x% =
          <pdq-input-arrows
            [disabled]="!formGroup.value['enableIncreaseRatesPercentage'] || !formGroup.value['enableOptimization']"
            [formControl]="formGroup.controls['increaseRatesPercentage']"
            [min]="0"
            [max]="100"
            placeholder="20"></pdq-input-arrows>
        </div>
      </div>
    </form>
  </div>
</div>
